import React, { useState, useEffect } from "react";
import Sidebar from "./sidebar";
import NavBar from "./navbar";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import useAuth from "./useAuth";
import { FaHome } from "react-icons/fa";
import axios from 'axios';


const Dashboard = () => {
  useAuth(); // Vérifier l'authentification
  const location = useLocation();
  const navigate = useNavigate();
  const { user, titre } = location.state || {};
  const user_id = localStorage.getItem("IDDDD");



  useEffect(() => {
    if (user_id) {
      document.title = "PayMe | Dashboard"; // Définit le titre de la page
    }
  }, [user_id]);

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <NavBar />
        <div className="row wrapper border-bottom white-bg page-heading">
          <div className="col-lg-12">
            <h2 className="d-flex align-items-center">
              <FaHome size={25} className="mr-2" />
              Dashboard
            </h2>
            <small>Aperçu de la performance.</small>

            <small id="hbreadcrumb" className="d-flex justify-content-end">
              <ol className="breadcrumb custom-breadcrumb">
                <li className="breadcrumb-item custom-breadcrumb-item">
                  <Link to={`/dashboard`}>Dashboard</Link>
                </li>
              </ol>
            </small>
          </div>
        </div>
        <div className="container mt-4">
          {/* Contenu de la page */}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
